// extracted by mini-css-extract-plugin
export default {"labelWithIconWrapper":"InputOptionsWithIcon_labelWithIconWrapper__Sbewi","iconWrapper":"InputOptionsWithIcon_iconWrapper__9ZQE9"};